import React from 'react';
import { motion } from 'framer-motion';
import { Loader, ArrowRight, ArrowLeft } from 'lucide-react';
import { FADE_UP } from '../../lib/anim';

const LABEL_STYLE = { fontFamily: 'var(--font-mono)', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.1em' };

export const RegistrationStep = ({ fileName, userData, setUserData, onSubmit, onBack, loading }) => (
  <motion.div {...FADE_UP}>
    <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
      <div style={{ display: 'inline-flex', padding: '8px 16px', background: 'var(--bg-elevated)', borderRadius: 'var(--radius-full)', marginBottom: '1rem', border: '1px solid var(--border-default)' }}>
        <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.75rem', color: 'var(--brand-purple)' }}>{fileName}</span>
      </div>
      <h2 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Quick details before we analyze</h2>
      <p style={{ color: 'var(--text-secondary)', fontSize: '0.9375rem' }}>Just your name and email — takes 10 seconds.</p>
    </div>

    <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '480px', margin: '0 auto' }} data-testid="registration-form">
      <div className="form-group" style={{ marginBottom: 0 }}>
        <label className="form-label" style={LABEL_STYLE}>Full Name *</label>
        <input type="text" required value={userData.full_name} onChange={e => setUserData({ ...userData, full_name: e.target.value })}
          className="form-input" placeholder="John Doe" data-testid="input-full-name" />
      </div>
      <div className="form-group" style={{ marginBottom: 0 }}>
        <label className="form-label" style={LABEL_STYLE}>Email *</label>
        <input type="email" required value={userData.email} onChange={e => setUserData({ ...userData, email: e.target.value })}
          className="form-input" placeholder="john@example.com" data-testid="input-email" />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="form-label" style={LABEL_STYLE}>Phone</label>
          <input type="tel" value={userData.phone} onChange={e => setUserData({ ...userData, phone: e.target.value })}
            className="form-input" placeholder="+971 XX XXX XXXX" data-testid="input-phone" />
        </div>
        <div className="form-group" style={{ marginBottom: 0 }}>
          <label className="form-label" style={LABEL_STYLE}>Nationality</label>
          <input type="text" value={userData.nationality} onChange={e => setUserData({ ...userData, nationality: e.target.value })}
            className="form-input" placeholder="Indian" data-testid="input-nationality" />
        </div>
      </div>
      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '0.8125rem', color: 'var(--text-secondary)', lineHeight: 1.5, cursor: 'pointer', marginTop: '0.25rem' }}>
        <input
          type="checkbox"
          required
          checked={!!userData.contact_consent}
          onChange={e => setUserData({ ...userData, contact_consent: e.target.checked })}
          data-testid="consent-checkbox"
          style={{ marginTop: '2px', accentColor: '#F67425', width: '16px', height: '16px', flexShrink: 0 }}
        />
        <span>
          I agree that Axpats may securely store my CV and details, and contact me about my migration options. *
        </span>
      </label>
      <div style={{ display: 'flex', gap: '12px', marginTop: '0.5rem' }}>
        <button type="button" onClick={onBack} className="btn" style={{ flex: 0, padding: '0.75rem 1.25rem', background: 'var(--bg-elevated)', border: '1px solid var(--border-default)' }}>
          <ArrowLeft size={18} />
        </button>
        <button type="submit" disabled={loading} className="btn btn-primary" style={{ flex: 1 }} data-testid="register-submit-btn">
          {loading ? <><Loader className="animate-spin" size={18} /> Processing...</> : <>Analyze My CV <ArrowRight size={18} /></>}
        </button>
      </div>
    </form>
  </motion.div>
);
